import { Component } from '@angular/core';
import { CoreModule } from '@app/core/core.module';
import { MatButton } from '@angular/material/button';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { MatIcon } from '@angular/material/icon';
import { UnauthFooterComponent } from '../../components/unauth-footer/unauth-footer.component';

@Component({
    selector: 'app-login-rate-limit',
    templateUrl: './login-rate-limit.component.html',
    styleUrl: './login-rate-limit.component.scss',
    imports: [
        MatIcon,
        MatButton,
        UnauthFooterComponent,
        TranslateModule,
    ],
})
export class LoginRateLimitComponent {
    constructor(private router: Router) {}

    backToLogin() {
        this.router.navigate(['login']);
    }
}
